
/* injects from baggage-loader */

'use strict';

export default class DialogMissionController {
	constructor($log, $timeout) {
		'ngInject';
		this.$log = $log;
		this.$timeout = $timeout;
		this.step = 0;
	}

	$onInit() {
		this.missionText = this.resolve.text;
		this.missionIcons = this.resolve.icons;
	}

	ok(){
		this.modalInstance.close(true);
	}

	cancel(){
		this.modalInstance.dismiss('cancel');
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/mission/mission.controller.js